var _path, _path2, _path3, _path4, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGooglePlayStore(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 26,
    viewBox: "0 0 24 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.1133 0.322266C0.820318 0.61525 0.722656 1.10516 0.722656 1.69112V23.3143C0.722656 23.9019 0.917979 24.3902 1.21256 24.6848L1.31023 24.7824L13.4426 12.65V12.4547L1.1133 0.322266Z",
    fill: "url(#paint0_linear_731_493)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3562 16.7586L13.3457 12.7465V12.4535L17.3578 8.44141L17.4555 8.53907L22.2505 11.2784C23.621 12.0613 23.621 13.3325 22.2505 14.1154L17.3562 16.7586Z",
    fill: "url(#paint1_linear_731_493)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4528 16.6625L13.343 12.5527L1.11133 24.7828C1.60124 25.2727 2.28486 25.2727 3.16542 24.8805L17.4528 16.6625Z",
    fill: "url(#paint2_linear_731_493)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4528 8.44252L3.16702 0.322226C2.28647 -0.167681 1.60124 -0.0700197 1.11133 0.419888L13.343 12.5523L17.4528 8.44252Z",
    fill: "url(#paint3_linear_731_493)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_731_493",
    x1: 7.08252,
    y1: 0.251357,
    x2: 7.08252,
    y2: 24.6011,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#267CAF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.286,
    stopColor: "#4A92B4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.767,
    stopColor: "#79BCBA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#88CEBC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_731_493",
    x1: 19.6765,
    y1: 9.61252,
    x2: 16.707,
    y2: 16.3293,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F48879"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.119,
    stopColor: "#F5907A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.713,
    stopColor: "#FBB777"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDC874"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_731_493",
    x1: 15.2574,
    y1: 14.7208,
    x2: 1.89587,
    y2: 25.5263,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EB413D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.167,
    stopColor: "#D94452"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.575,
    stopColor: "#AF487A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.862,
    stopColor: "#954B92"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#894A9C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_731_493",
    x1: 2.84424,
    y1: 0.911877,
    x2: 15.6249,
    y2: 10.6716,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#54C0AC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DDE79A"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGooglePlayStore);
export default __webpack_public_path__ + "static/media/google-play-store.a39d4e3a9a2b199683413bf4d58ae11c.svg";
export { ForwardRef as ReactComponent };